const labels = []

labels['administracao'] = 'Unidade Administrativa'
labels['administracao.title'] = 'Unidade Administrativa'

labels['exercicioLabel'] = 'Exercício'
labels['exercicio.placeholder'] = 'Exercício'

labels['mesLabel'] = 'Mês'
labels['janeiro'] = 'Janeiro'
labels['fevereiro'] = 'Fevereiro'
labels['marco'] = 'Março'
labels['abril'] = 'Abril'
labels['maio'] = 'Maio'
labels['junho'] = 'Junho'
labels['julho'] = 'Julho'
labels['agosto'] = 'Agosto'
labels['setembro'] = 'Setembro'
labels['outubro'] = 'Outubro'
labels['novembro'] = 'Novembro'
labels['dezembro'] = 'Dezembro'

labels['nome'] = 'Nome'
labels['nome.placeholder'] = 'Nome'

labels['cpf'] = 'CPF'
labels['cpf.placeholder'] = 'CPF'

labels['cargo'] = 'Cargo'
labels['cargo.title'] = 'Cargo'

labels['removerFitlroAplicado'] = 'Remover filtro'
labels['atualizarFiltro'] = 'Atualizar'

labels['filtrosLabel'] = 'Filtros'

labels['criteriosAtualizados'] = ''

labels['nenhumFiltroAplicado'] = 'Nenhum filtro aplicado'

export default labels
